// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PickListsPage = lazy(() => import('./pages/PickListsPage'));
const PickPackShipPage = lazy(() => import('./pages/PickPackShipPage'));
const CarriersPage = lazy(() => import('./pages/CarriersPage'));
const ShippingLabelsPage = lazy(() => import('./pages/ShippingLabelsPage'));
const TrackingPage = lazy(() => import('./pages/TrackingPage'));
const CustomsPage = lazy(() => import('./pages/CustomsPage'));
const BackordersPage = lazy(() => import('./pages/BackordersPage'));

export const FulfillmentRoutes: RouteObject = {
  path: 'fulfillment',
  element: <ModuleGuard moduleId="operations.fulfillment" />,
  children: [
    { path: 'pick-lists', element: <PickListsPage />, handle: { crumb: 'Pick Lists' } },
    { path: 'pick-pack-ship', element: <PickPackShipPage />, handle: { crumb: 'Pick Pack Ship' } },
    { path: 'carriers', element: <CarriersPage />, handle: { crumb: 'Carriers' } },
    { path: 'shipping-labels', element: <ShippingLabelsPage />, handle: { crumb: 'Shipping Labels' } },
    { path: 'tracking', element: <TrackingPage />, handle: { crumb: 'Tracking' } },
    { path: 'customs', element: <CustomsPage />, handle: { crumb: 'Customs' } },
    { path: 'backorders', element: <BackordersPage />, handle: { crumb: 'Backorders' } },
  ],
};
